export const serializeBriefData = (brief) => ({
    logo_name: {
        brand_name: brief.brandName,
        slogan: brief.slogan,
    },
    industries: brief.industries,
    description: brief.keywords.join(','),
});
